import { render, staticRenderFns } from "./ViewData.vue?vue&type=template&id=33bcb064&scoped=true"
import script from "./ViewData.vue?vue&type=script&lang=js"
export * from "./ViewData.vue?vue&type=script&lang=js"
import style0 from "./ViewData.vue?vue&type=style&index=0&id=33bcb064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bcb064",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
